export default __webpack_public_path__ + "static/media/Pharaoh_2.3fa6e82b.png";